import { Editor, Node } from 'slate';
import { isElementType } from '.';

// Is string a valid URL
export const isUrl = (url: string): boolean => {
	if (!url) {
		return false;
	}

	url = url.trim();

	if (url.includes(' ')) {
		return false;
	}

	try {
		new URL(url);
		return true;
	} catch {
		return false;
	}
};

// Is node a link
export const isLink = (node: Node) => isElementType(node, 'link');

// Is node (within editor) a 'link' type
export const isLinkActive = (editor: Editor): boolean => {
	const linkEntries = Array.from(
		Editor.nodes(editor, {
			match: isLink,
		})
	);

	return !!linkEntries.length;
};
